export enum AssetColor {
  AssetSeed = "AssetSeed",
  AssetChemical = "AssetChemical",
  AssetFertiliser = "AssetFertiliser",
}
